import { StockEventType, StockLotCRUDSchema } from 'types/inventory';
import useSnackbar from 'hooks/useSnackbar';
import { StockLocationSchemaLite } from 'types/clientV2/stockLocations';
import { useMoveWarningContext } from 'views/warehouse/MoveWarningContext';
import { useCreateStockEventsMutation } from 'store/slices/clientV2/stockEvents';

export const useTransferStockLot = () => {
  const [
    createStockEvents,
    {
      isLoading: isLoadingCreateStockEvents,
      isSuccess: isSuccessCreateStockEvents,
    },
  ] = useCreateStockEventsMutation();
  const { dispatchSuccessSnackbar, dispatchErrorSnackbar } = useSnackbar();
  const { validateMoveAndShowWarning } = useMoveWarningContext();

  const handleTransferStockLot = async (
    scannedStockLotToBeMoved: Pick<StockLotCRUDSchema, 'org' | 'id' | 'lotId'>,
    scannedDestinationLocation: StockLocationSchemaLite
  ) => {
    if (!scannedStockLotToBeMoved || !scannedDestinationLocation) {
      return;
    }

    // Validate the move - this will show warning if there are issues
    validateMoveAndShowWarning(
      scannedStockLotToBeMoved,
      scannedDestinationLocation
    );

    try {
      await createStockEvents({
        eventType: StockEventType.MOVE,
        stockLot: scannedStockLotToBeMoved.id,
        stockLocation: scannedDestinationLocation.id,
      }).unwrap();

      dispatchSuccessSnackbar(`Stock lot moved to location`);
    } catch (err) {
      dispatchErrorSnackbar('Failed to transfer stock lot.');
    }
  };

  return {
    handleTransferStockLot,
    isLoadingTransferStockLot: isLoadingCreateStockEvents,
    isSuccessTransferStockLot: isSuccessCreateStockEvents,
  };
};
